import { render } from "./ColorAction.vue?vue&type=template&id=1c88a1f0"
import script from "./ColorAction.vue?vue&type=script&lang=js"
export * from "./ColorAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__